import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const EnvelopeOpenIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon data-cy="messageReadIcon" viewBox={viewBox} {...rest}>
            <SvgIcon viewBox={viewBox} {...rest}>
                <rect fill="none" y="0.01" width="24" height="24" />
                <path
                    fill="currentColor"
                    d="M21.84,20.12H2.12V6.62L12,2l9.86,4.62ZM3.32,18.92H20.64V7.38L12,3.32,3.32,7.38Z"
                />
                <polygon
                    fill="currentColor"
                    points="12 13.79 2.39 7.5 3.05 6.5 12 12.36 20.91 6.5 21.57 7.5 12 13.79"
                />
                <rect
                    fill="currentColor"
                    x="1.01"
                    y="14.96"
                    width="10.87"
                    height="1.2"
                    transform="translate(-9.3 9.59) rotate(-46.75)"
                />
                <rect
                    fill="currentColor"
                    x="16.9"
                    y="10.11"
                    width="1.2"
                    height="10.9"
                    transform="translate(-5.91 16.28) rotate(-43.41)"
                />
            </SvgIcon>{" "}
        </SvgIcon>
    );
};
